export const WATERFALL_SEARCHABLE_CELL_SELECT_VISIBLE_ITEM_LIMIT = 8;
